import { createSlice } from '@reduxjs/toolkit'
import { FormValuesReimburse } from '../../../types/reimburse'

const reimburseSlice = createSlice({
  name: 'reimburse',
  initialState: {
    isEdit: false,
    dataSave: {} as FormValuesReimburse
  },
  reducers: {
    setEdit: (state, action) => {
      state.isEdit = action.payload
    },
    setDataSave: (state, action) => {
      state.dataSave = action.payload
    }
  }
})

export const { setEdit, setDataSave } = reimburseSlice.actions

export default reimburseSlice.reducer
